import React, { useCallback } from "react";
import { MostRead } from "@bloomberg/media-ui-article";
import type { MostReadProps } from "@bloomberg/media-ui-article/types/MostRead";

export type MostReadComponentProps = MostReadProps & {
    brand: string;
};

const DEFAULT_SITES = [
    "BUSINESS",
    "TECHNOLOGY",
    "MARKETS",
    "PURSUITS",
    "BUSINESSWEEK",
];

export function getMostReadQueryParams(brand: string): string {
    return new URLSearchParams(
        ["VIEW", "GADFLY"].includes(brand)
            ? {
                  sites: brand,
                  limit: "7",
              }
            : {
                  sites: DEFAULT_SITES.join(","),
                  limit: "5",
              }
    ).toString();
}

export default function MostReadComponent({ brand }: MostReadComponentProps) {
    const [stories, setStories] = React.useState<[] | any>(null);

    const fetchmostReadStories = async () => {
        const queryParams = getMostReadQueryParams(brand);

        const result = await fetch(
            `/article/api/most-read/stories?${queryParams}`
        );
        const data = await result.json();

        setStories(data);
    };

    React.useEffect(() => {
        fetchmostReadStories();

        // TODO: This function can be passed as a prop to MostRead media-ui component
        window?.dataLayer?.push({
            event: "mostReadImpression",
            eventAction: "impression",
            eventCategory: "recirc",
            eventLabel: "mostread",
        });
    }, []);

    const mostReadTrackingFn = useCallback(
        (eventAction: string, eventLabel: string) => {
            window?.dataLayer?.push({
                event: "mostReadClick",
                eventCategory: "recirc",
                eventAction,
                eventLabel,
            });
        },
        []
    );

    return <MostRead items={stories} trackingFunction={mostReadTrackingFn} />;
}
